import React, { useState } from "react";
import AdminCreateUser from "./Components/AdminCreateUser/AdminCreateUser.jsx";
import AdminGetUsers from "./Components/AdminGetUsers/AdmintGetUsers.jsx";
import AdminEditUser from "./Components/AdminEditUser/AdminEditUser.jsx";
/*import AdminDeleteUser from "./Components/AdminDeleteUser" */
import "../Admin/Admin.css"
/* import { use } from "video.js/dist/types/tech/middleware"; */

const AdminDashboard = ( ) => {
  const [selectedTool, setSelectedTool] = useState(null);
  const [toolKey, setToolKey] = useState(0);

  const handleToolClick = (toolName) => {
    setSelectedTool(toolName);
    setToolKey(prev => prev +1);
    console.log('Clicked:', toolName, 'toolKey:', toolKey + 1);
  };

  const renderToolComponent = () => {
    switch (selectedTool) {
      case "createUser":
        return <AdminCreateUser toolKey={toolKey}/>
      case "getUsers":
        return <AdminGetUsers toolKey={toolKey}/>;
      case "editUser":
        return <AdminEditUser />;
   /*  case "deleteUser":
        return <AdminDeleteUser />; */
      default:
        return null
    }
  }
  return (
    <div className="admin-dashboard">
      <div className="admin-container">
        <h2>Admin Dashboard of Vix Academy</h2>
        <p>Manage users, content, and system settings.</p>
      </div>


      <div className="admin-tools" >
        <div className="tools-container">
          <div style={{backgroundColor: "#fff", padding:"2px 8px", borderRadius:"12px"}}>
            <h3>TOOLS</h3>
            <ul style={{listStyle: "none"}} >
              <li style={{ cursor: "pointer" }} onClick={() => handleToolClick("createUser")}>
                  <div style={{ fontSize:"20px", fontWeight:"400"}}><a>Create User:</a></div><div> Create new user</div>
              </li>
              <li style={{ cursor: "pointer" }} onClick={() => handleToolClick("getUsers")}>
                <div style={{ fontSize:"20px", fontWeight:"400"}}><a>Get Users:</a></div><div>Preview users and their details</div>
              </li>
              {/* <li style={{ cursor: "pointer" }} onClick={() => handleToolClick("")}>
                <a >Edit User:</a> Click  User Id on the 'Get Users' details</li>*/}
              <li style={{ cursor: "pointer" }} onClick={() => handleToolClick("getUsers")}>
                <a>Delete User:</a> Click on an Id to enter & delete 
              </li> 
            </ul>
          </div>
          <div>
            <h3>QUICK LINKS</h3>
            <ul style={{listStyle: "none"}}>
              <li><a href="/assets/videos/adminTutorial.mpeg">Admin Tutorial</a></li>
              <li><a href="/assets/docs/adminGuide.pdf">Admin Guide Doc</a></li>
              <li><a href="/assets/utils/userManager.jsx.">User Manager Tool</a></li>
            </ul>
          </div>  
        </div>
      {/*Tools compartment here */}
      <div className="admin-tools-compartment">
        {renderToolComponent()}
      </div>
      </div>
    </div>
  );
};

export default AdminDashboard;